import { Button, Box } from '@mui/material';
import { styled } from '@mui/system';

import Color from '@tool/color';

const LineBox = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '40px',
  padding: '0 16px',

  '& .arrow-111': {
    flex: 1,
    display: 'inline-flex',
    justifyContent: 'flex-end',
  },
  '& svg': { transform: 'rotate(270deg)' },
  '&.active': {
    backgroundColor: Color.primary,

    '& .industry-111': { color: Color.whiteColor(1) },
    '& .industry-113': { color: Color.whiteColor(0.5) },
  },
}));

const DButton = styled(Button)(() => ({
  padding: '4px 8px',
  fontSize: '14px',
  fontWeight: 600,
  color: Color.blackColor(0.85),

  '&.industry-100': {
    cursor: 'default',
    backgroundColor: Color.blackColor(0),
  },
}));

const EButton = styled(Button)(() => ({}));

const FButton = styled(Button)(() => ({
  padding: '4px 8px',
  marginLeft: '4px',
  fontSize: '14px',
  fontWeight: 400,
  color: Color.blackColor(0.5),
}));

const IndustryButton = styled(Button)(() => ({
  marginTop: '8px',
  padding: '8px 16px',
  fontSize: '14px',
  fontWeight: 400,
  color: Color.blackColor(0.65),
}));

const IndustryLine = styled(Box)(() => ({
  flex: 1,
  display: 'inline-block',
  marginTop: '10px',

  '& .active-111': {
    fontWeight: 600,
    color: Color.primary,
  },
}));

export {
  LineBox, DButton, EButton, FButton, IndustryButton, IndustryLine,
};
